// *______________________________________________________
export const DEFAULT_AWS_REGION = 'us-east-1';
const EC_AWS_ROOT = 'https://console.aws.amazon.com/ec2';

const path = (root, sublink) => {
  return `${root}${sublink}`;
};

export const getBaseLink = (region, type) => {
  if (region === DEFAULT_AWS_REGION) {
    return `https://${DEFAULT_AWS_REGION}.console.aws.amazon.com/${type}/home?region=${DEFAULT_AWS_REGION}`;
  } else {
    return `https://${region}.console.aws.amazon.com/${type}/home?region=${region}`;
  }
};

const getS3BaseLink = () => `https://s3.console.aws.amazon.com/s3`;
// * ______________________________________________________

const AWS_LINKS = {
  IAM: {
    ROOT: (userName, userId, region) => path(getBaseLink(region, 'iam'), `#/users/${userName}`),
  },

  VPC: {
    ROOT: (vpcName, VpcId, region) =>
      path(getBaseLink(region, 'vpc'), `#VpcDetails:VpcId=${VpcId}`),
  },

  EC2: {
    ROOT: (resourceName, resourceId, region) => path(getBaseLink(region, 'ec2'), `#`),

    INSTANCE: (resourceId, region) =>
      path(getBaseLink(region, 'ec2'), `#InstanceDetails:instanceId=${resourceId}`),

    SNAPSHOT: (resourceId, region) =>
      path(getBaseLink(region, 'ec2'), `#SnapshotDetails:snapshotId=${resourceId}`),

    VOLUME: (resourceId, region) =>
      path(getBaseLink(region, 'ec2'), `#VolumeDetails:volumeId=${resourceId}`),

    AMI: (resourceId, region) =>
      path(getBaseLink(region, 'ec2'), `#ImageDetails:imageId=${resourceId}`),

    KEYPAIR: (resourceId, region) =>
      path(getBaseLink(region, 'ec2'), `#KeyPairDetails:keyName=${resourceId}`),

    SECURITYGROUPS: (resourceId, region) =>
      path(getBaseLink(region, 'ec2'), `#SecurityGroup:groupId=${resourceId}`),
  },

  LAMBDA: {
    ROOT: (lambdaName, resourceId, region) =>
      path(getBaseLink(region, 'lambda'), `#functions/${lambdaName}`),
  },

  S3: {
    ROOT: (bucketName, bucketId, region) =>
      path(getS3BaseLink(), `/buckets/${bucketName}?region=${region}`),
  },

  AG: {
    ROOT: (resourceName, resourceId, region) =>
      path(getBaseLink(region, 'apigateway'), `#/apis/${resourceId}`),
  },
};

const GCP_CONSOLE_BASE_URL = 'https://console.cloud.google.com/';

const GCP_LINKS = {
  SERVICEACCOUNT: {
    ROOT: (resourceName, resourceId, region, projectId) =>
      `${GCP_CONSOLE_BASE_URL}iam-admin/serviceaccounts?project=${projectId}`,
  },
  INSTANCE: {
    ROOT: (resourceName, resourceId, region, projectId) =>
      `${GCP_CONSOLE_BASE_URL}compute/instancesDetail/zones/${region}/instances/${resourceId}?hl=en&project=${projectId}`,
  },
  CLOUDFUNCTION: {
    ROOT: (resourceName, resourceId, region, projectId) =>
      `${GCP_CONSOLE_BASE_URL}functions/list?project=${projectId}`,
  },
  STORAGE: {
    ROOT: (resourceName, resourceId, region, projectId) =>
      `${GCP_CONSOLE_BASE_URL}storage/browser/${resourceName}`,
  },
  FIRESTORE: {
    ROOT: (resourceName, resourceId, region, projectId) =>
      `${GCP_CONSOLE_BASE_URL}firestore/databases/?project=${projectId}`,
  },
  DATASTORE: {
    ROOT: (resourceName, resourceId, region, projectId) =>
      `${GCP_CONSOLE_BASE_URL}datastore/databases/?project=${projectId}`,
  },
  CLOUDKMS: {
    ROOT: (resourceName, resourceId, region, projectId) =>
      `${GCP_CONSOLE_BASE_URL}security/kms/keyrings?project=${projectId}`,
  },
  NETWORK: {
    ROOT: (resourceName, resourceId, region, projectId) =>
      `${GCP_CONSOLE_BASE_URL}networking/networks/details/${resourceId}?project=${projectId}`,
  },
};

export const generateAWSResouceLink = resourceData => {
  const { service, resourceId, resourceName, region } = resourceData;
  const [serviceType, serviceCategory] = service.split(':');

  if (serviceCategory) {
    // *@ If serviceCategory is provided
    const _link = AWS_LINKS[serviceType][serviceCategory]?.(resourceId, region);
    return _link;
  } else {
    // *@ ROOT is the default case of service, if no serviceCategory is provided
    const _link = AWS_LINKS[serviceType]?.ROOT(resourceName, resourceId, region);
    return _link;
  }
};

export const generateGCPResourceLink = resourceData => {
  const { service, resourceId, resourceName, region, projectId } = resourceData;

  const serviceKey = service.replace(/ /g, '');
  if (GCP_LINKS[serviceKey] && GCP_LINKS[serviceKey].ROOT) {
    return GCP_LINKS[serviceKey].ROOT(resourceName, resourceId, region, projectId);
  }
  return GCP_CONSOLE_BASE_URL;
};
